import { render, staticRenderFns } from "./InquiryWidgetDetails.vue?vue&type=template&id=2873b345&"
import script from "./InquiryWidgetDetails.vue?vue&type=script&lang=js&"
export * from "./InquiryWidgetDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports